'use client';

import { Suspense, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import dynamic from 'next/dynamic';

import { useShoppingCartContext } from '@/components/Providers/ShoppingCartProvider';
import { useAlgoliaFailover } from '@/hooks/useAlgoliaFailover';

import DontForgetSectionAlgolia from './DontForgetSectionAlgolia';

const DontForgetSectionStrapi = dynamic(() => import('./DontForgetSectionStrapi'), { ssr: true });

const DontForgetSection = () => {
  const { cart, isEnrollmentFlow } = useShoppingCartContext();
  const { isAlgoliaDown } = useAlgoliaFailover();
  const stableCartItems = useMemo(() => cart?.map(ci => ci.itemCode || ci.id?.toString() || '') || [], [cart]);
  if (isEnrollmentFlow) return <></>;

  return isAlgoliaDown ? (
    <DontForgetSectionStrapi />
  ) : (
    <ErrorBoundary
      fallback={
        <Suspense>
          <DontForgetSectionStrapi />
        </Suspense>
      }
    >
      {stableCartItems.length === 0 ? (
        <Suspense>
          <DontForgetSectionStrapi />
        </Suspense>
      ) : (
        <DontForgetSectionAlgolia itemCode={stableCartItems} />
      )}
    </ErrorBoundary>
  );
};

export default DontForgetSection;
